var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9987 1.99967C7.91536 1.99967 8.66536 2.74967 8.66536 3.66634C8.66536 4.58301 7.91536 5.33301 6.9987 5.33301C6.08203 5.33301 5.33203 4.58301 5.33203 3.66634C5.33203 2.74967 6.08203 1.99967 6.9987 1.99967ZM6.9987 10.333C9.2487 10.333 11.832 11.408 11.9987 11.9997H1.9987C2.19036 11.3997 4.75703 10.333 6.9987 10.333ZM6.9987 0.333008C5.15703 0.333008 3.66536 1.82467 3.66536 3.66634C3.66536 5.50801 5.15703 6.99967 6.9987 6.99967C8.84036 6.99967 10.332 5.50801 10.332 3.66634C10.332 1.82467 8.84036 0.333008 6.9987 0.333008ZM6.9987 8.66634C4.7737 8.66634 0.332031 9.78301 0.332031 11.9997V13.6663H13.6654V11.9997C13.6654 9.78301 9.2237 8.66634 6.9987 8.66634Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.894988bc55764b3ea89291648fff54a8.svg";
export { ForwardRef as ReactComponent };